import { render, staticRenderFns } from "./JflowRestitution.vue?vue&type=template&id=30bf37dc&"
import script from "./JflowRestitution.vue?vue&type=script&lang=js&"
export * from "./JflowRestitution.vue?vue&type=script&lang=js&"
import style0 from "./JflowRestitution.vue?vue&type=style&index=0&id=30bf37dc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports